import React, { useEffect, useState, useRef, createElement } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LandingScreen } from './components/LandingScreen';
import { QuizQuestion } from './components/QuizQuestion';
import { AnalysisScreen } from './components/AnalysisScreen';
import { ResultsPage } from './components/ResultsPage';
import { BridgePage } from './components/BridgePage';
import { QUIZ_QUESTIONS, MetabolicType } from './lib/constants';
type Step = 'landing' | 'quiz' | 'analysis' | 'results' | 'bridge';
export function App() {
  // Set document title
  useEffect(() => {
    document.title = 'DDT Código Metabólico';
  }, []);
  // Meta Pixel
  useEffect(() => {
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    f.fbq('init', '1964119154988196');
    f.fbq('track', 'PageView');
  }, []);
  const containerRef = useRef<HTMLDivElement>(null);
  const [step, setStep] = useState<Step>('landing');
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState<MetabolicType[]>([]);
  const [resultType, setResultType] = useState<MetabolicType | null>(null);
  const handleStartQuiz = () => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead', {
        content_name: 'Inicio Quiz Metabolico'
      });
    }
    setAnswers([]);
    setCurrentQuestionIndex(0);
    setResultType(null);
    setStep('quiz');
  };
  const handleAnswer = (type: MetabolicType) => {
    const newAnswers = [...answers, type];
    setAnswers(newAnswers);
    if (currentQuestionIndex < QUIZ_QUESTIONS.length - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
    } else {
      calculateResult(newAnswers);
      setStep('analysis');
    }
  };
  const calculateResult = (finalAnswers: MetabolicType[]) => {
    const scores: Record<MetabolicType, number> = {
      jaguar: 0,
      colibri: 0,
      oso: 0
    };
    // Apply weighted scoring: each answer contributes its question's weight
    finalAnswers.forEach((ans, idx) => {
      const weight = QUIZ_QUESTIONS[idx]?.weight ?? 1;
      scores[ans] += weight;
    });
    // Determine winner by highest weighted score
    // Tiebreak priority: jaguar > colibri > oso
    const types: MetabolicType[] = ['jaguar', 'colibri', 'oso'];
    let winner: MetabolicType = 'jaguar';
    let maxScore = 0;
    for (const t of types) {
      if (scores[t] > maxScore) {
        maxScore = scores[t];
        winner = t;
      }
    }
    setResultType(winner);
  };
  const handleAnalysisComplete = () => {
    setStep('results');
  };
  const handleContinueToBridge = () => {
    setStep('bridge');
  };
  // Scroll to top on every step change
  useEffect(() => {
    containerRef.current?.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }, [step]);
  return <div className="min-h-screen bg-gray-100 flex items-center justify-center w-full" data-id="element-0">
      <div ref={containerRef} className="w-full h-[100dvh] bg-white shadow-2xl overflow-y-auto hide-scrollbar relative sm:max-w-md sm:h-[850px] sm:rounded-[2.5rem] sm:border-[8px] sm:border-gray-900" data-id="element-1">
        <AnimatePresence mode="wait" data-id="element-2">
          {step === 'landing' && <LandingScreen key="landing" onStart={handleStartQuiz} data-id="element-3" />}

          {step === 'quiz' && <QuizQuestion key={`question-${currentQuestionIndex}`} question={QUIZ_QUESTIONS[currentQuestionIndex]} currentIndex={currentQuestionIndex} totalQuestions={QUIZ_QUESTIONS.length} onAnswer={handleAnswer} data-id="element-4" />}

          {step === 'analysis' && <AnalysisScreen key="analysis" onComplete={handleAnalysisComplete} data-id="element-5" />}

          {step === 'results' && resultType && <ResultsPage key="results" resultType={resultType} onContinue={handleContinueToBridge} data-id="element-6" />}

          {step === 'bridge' && resultType && <BridgePage key="bridge" resultType={resultType} data-id="element-7" />}
        </AnimatePresence>
      </div>
    </div>;
}